import { CompanyData, ProjectPayload } from '@desygner/ui-data-access-projects';

export enum Status {
  UnauthorizedUser = 'unauthorizedUser',
  Loading = 'loading',
  ProjectNotFound = 'projectNotFound',
  Loaded = 'loaded',
  ProjectLocked = 'projectLocked',
  CredentialsInvalid = 'credentialsInvalid',
  UnknownError = 'unknownError',
}

export type User = {
  userToken: string;
  auth: 'Basic' | 'Bearer';
};

export type Company =
  | (CompanyData & {
      is_workspace: boolean;
    })
  | {
      id: number;
      name: string;
      domain: string;
      is_workspace: boolean;
      features: CompanyData['features'];
      parent_domain: string | null;
    };

export type MediaType = {
  [pageId: number]: {
    [svgId: string]: {
      pageId: number;
      svgId: string;
      totalDuration?: number;
      currentTime?: number;
      volume?: number;
    };
  };
};

export type Collaborator = {
  id: number | string;
  permissionUserId?: number;
  name: string;
  sourceUrl?: string;
  permissionType?: 'shared' | 'owner';
  permissionId?: number;
  invitation?: {
    isPending: boolean;
    isExpired: boolean;
    membershipId: number;
    invitedAt: string;
  };
  email: string;
};

export type ViewerStore = {
  status: Status;
  isTranslationLoaded: boolean;
  project: {
    type: ProjectPayload['type'];
    id: string;
    isOwner: boolean | null;
  };
  pageMode: 'scroll' | 'single';
  selectedPageNumber: number;
  zoom: number;
  viewOptions: 'fit' | 'fill' | null;
  pageDimension: {
    width: number;
    height: number;
  } | null;
  user: User;
  company: Company;
  theme: Theme;
  mediaList: MediaType | null;
  currentPlayingMedia: MediaType[number][string] | null;
  collaborators: Collaborator[];
};

export enum Theme {
  Light = 'light',
  Dark = 'dark',
}

export enum ProjectAction {
  Download = 'download',
  Share = 'share',
}
